import { IUpdateLanguage, LocaleActionKind } from './types'

export const updateLanguage = (language: string): IUpdateLanguage => ({
  type: LocaleActionKind.UpdateLanguage,
  meta: { language }
})
